import React, { createContext, useContext, useReducer } from 'react';

const ContentSelectorContext = createContext();

const Selector = ({ id, ...props }) => {
	const { state, actions } = useContext(ContentSelectorContext);
	if(state.id !== false) return null;

	return (
		React.cloneElement(props.children, {
			onClick:() => actions.open(id),
		})
	)
};

const Content = ({ id, ...props }) => {
	const { state } = useContext(ContentSelectorContext);
	if(state.id != id) return null;

	return props.children;
};

const CloseButton = (props) => {
	const { state, actions } = useContext(ContentSelectorContext);
	if(state.id === false) return null;

	return (
		React.cloneElement(props.children, {
			onClick:() => actions.close(),
		})
	)
};

const useCloseAction = () => {
	const {actions} = useContext(ContentSelectorContext);
	return actions.close;
}

const reducer = (state, action) => { 
	switch(action.type) {
		case 'SET_CONTENT':
			return {
				...state,
				id:action.payload,
			};

		default:
			return state;
	}
};

const ContentSelector = (props) => {
	const [ state, dispatch ] = useReducer(reducer, {
		id:false,
	});

	const actions = {
		open:function(id) {
			dispatch({ type:'SET_CONTENT', payload:id });
		},
		close:function() {
			dispatch({ type:'SET_CONTENT', payload:false });
		},
	};

	return (
		<ContentSelectorContext.Provider
			value={{ state, actions }}
		>
			{props.children}
		</ContentSelectorContext.Provider>
	)
};

ContentSelector.Selector = Selector;
ContentSelector.Content = Content;
ContentSelector.CloseButton = CloseButton;
ContentSelector.useCloseAction = useCloseAction;

export default ContentSelector;